// ap-click-track.js — portal attribution tracking
// Loaded on all portal pages via Shopify Script Tag.
// Exits immediately on non-portal URLs so it is a safe no-op everywhere else.
(function _apTrackClicks() {
  // Only activate on /pages/*-portal URLs
  var pp = window.location.pathname.match(/\/pages\/([^/?#]+)/);
  if (!pp || !/-portal$/.test(pp[1])) return;

  if (document._apClickTrackWired) return;
  document._apClickTrackWired = true;

  var portalSlug = pp[1];
  var base = typeof window.__PACELINE_API__ !== 'undefined'
    ? window.__PACELINE_API__
    : 'https://paceline-rye-production.up.railway.app';

  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var m = link.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m || !m[1] || m[1] === 'all') return;
    var handle = m[1];

    // Walk up to find the card container (sibling of another product link)
    var card = link;
    while (card.parentElement && card.parentElement !== document.body) {
      var siblings = [].slice.call(card.parentElement.children);
      if (siblings.length > 1 && siblings.some(function (c) {
        return c !== card && c.querySelector('a[href*="/products/"]');
      })) break;
      card = card.parentElement;
    }

    // Brand detection
    function getBrand(root) {
      var el = root.querySelector('[class*="-brand"],[class*="-vendor"],[class*="brand"],[class*="vendor"]');
      if (!el) return '';
      return (el.getAttribute('data-brand') || el.getAttribute('data-vendor') || el.textContent || '').trim();
    }
    var brand = getBrand(link) || getBrand(card);
    if (!brand) {
      var anc = link;
      while (anc && anc !== document.body) {
        brand = anc.getAttribute && (anc.getAttribute('data-brand') || anc.getAttribute('data-vendor') || '');
        if (brand) break;
        anc = anc.parentElement;
      }
    }

    var titleEl = card.querySelector('[class*="-name"],[class*="-title"]');
    var title = titleEl ? titleEl.textContent.trim() : '';
    var productId = card.dataset && (card.dataset.productId || card.dataset.id) || null;

    // Section detection
    var section = 'unknown';
    var node = card;
    while (node && node !== document.body) {
      var cls = (node.className || '').toLowerCase();
      var nid = (node.id || '').toLowerCase();
      var combined = cls + nid;
      if (/flash/.test(combined))                                    { section = 'flash-picks';  break; }
      if (/rise/.test(combined))                                     { section = 'on-the-rise';  break; }
      if (/kit/.test(combined))                                      { section = 'weekly-kit';   break; }
      if (/seasonal|mother|father|holiday|pride/.test(combined))    { section = 'seasonal';     break; }
      if (/trending|spotlight|sp-sec/.test(combined))               { section = 'trending';     break; }
      if (/inspir|workout-gear/.test(combined))                     { section = 'inspiration';  break; }
      if (/search/.test(combined))                                   { section = 'search';       break; }
      if (/bundle/.test(combined))                                   { section = 'bundles';      break; }
      node = node.parentElement;
    }

    var sid = localStorage.getItem('ap_vsid');
    if (!sid) {
      sid = Date.now().toString(36) + Math.random().toString(36).slice(2);
      try { localStorage.setItem('ap_vsid', sid); } catch (e) { sid = ''; }
    }
    var customerId = null;
    var customerEmail = null;
    if (window.__AP_PREFS__ && window.__AP_PREFS__.customerId) {
      customerId = String(window.__AP_PREFS__.customerId);
      customerEmail = window.__AP_PREFS__.email || null;
    } else if (window.__AP_CID__) {
      customerId = String(window.__AP_CID__);
      customerEmail = window.__AP_CEMAIL__ || null;
    }

    try {
      sessionStorage.setItem('ap_last_click', JSON.stringify({ handle: handle, brand: brand, placement: section, ts: Date.now() }));
    } catch (err) { /* storage unavailable */ }

    fetch(base + '/api/attribution', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      keepalive: true,
      body: JSON.stringify({
        productId:     productId || handle,
        handle:        handle,
        brand:         brand,
        title:         title,
        placement:     section,
        portal:        portalSlug,
        sessionId:     sid,
        customerId:    customerId,
        customerEmail: customerEmail,
      }),
    }).catch(function () {});
  });
})();
